import {receiveFeedsAction, requestFeedsAction} from "./actions";
import FeedsRepository from "../_repositories/feedRepository";
import Feed from "../_data/models/Feed";
import {addDataAction} from "../_data/actions";
import * as _ from "lodash";
import {dataByResourceNameSelector} from "../_data/selectors";
import {toggleLike} from "../_data/middlewares";
import {feedsSelector} from "./selectors";
import {push} from "react-router-redux";
import {FeedsRoutes} from "../routes";

export function initializeFeeds(openModal, selectedFeedId) {
    return (dispatch, getState) => {
        if (openModal && !feedsSelector(getState()).get(selectedFeedId))
            dispatch(push(FeedsRoutes.index()));
        else
            dispatch(fetchFeeds());
    }
}

export function fetchFeeds(cursor: number = null, page: number = null, perPage: number = 5) {
    return (dispatch) => {
        dispatch(requestFeedsAction());
        FeedsRepository.get(cursor, page, perPage).then(data => {
            const {feeds, meta} = data;

            _.chain(feeds)
                .groupBy((f: any) => f.resource)
                .map((value, key) => {
                    return {resource: key, value: value.map(v => v.resource_reference)};
                })
                .forEach((map) => {
                    dispatch(addDataAction({
                        resource: map.resource,
                        data: map.value
                    }));
                }).value();

            return dispatch(receiveFeedsAction({
                meta: meta,
                feeds: feeds
            }));
        });
    }
}

export function toggleLikeFeed(feed: Feed) {
    return (dispatch, getState) => {
        const model = dataByResourceNameSelector(getState(), feed.resource).get(feed.trackableId)
        dispatch(toggleLike(model));
    }
}


// WEBPACK FOOTER //
// ./app/client/activityFeeds/middlewares.ts